import type { IRogue } from "../services/RogueTypes"

// When loading the BV client script, we need to specify which store
const BV_SCRIPT_SITES: { [key: string]: string } = {
  1  : 'rogue',
  2  : 'roguecanada',
  3  : 'rogueapo',
  4  : 'rogueeurope',
  14 : 'rogueaustralia',
  18 : 'rogueaustralia',
}

const BV_LOCALE_SITES: { [key: string]: string } = {
  1  : 'en_US',
  2  : 'en_CA',
  4  : 'en_GB',
  14 : 'en_AU',
  18 : 'en_AU',
}

const loadedScripts: { [key: string]: Promise<unknown> } = {}

export function loadScript(input: string | { script: string, id?: string, async?: boolean, addToBody?: boolean, }, rogue: IRogue) {
  let script: string = ''
  let id: string | undefined
  let sriHash: string | undefined
  let asyncLoad: boolean = false
  let addToBody: boolean = false

  if (typeof input === 'string') {
    script = input
  } else {
    asyncLoad = !!input.async
    id = input.id
    addToBody = !!input.addToBody
    script = input.script
  }

  if (!script) {
    throw new Error('Invalid script load')
  }

  if (script === 'BV') {
    const bvSiteCode = BV_SCRIPT_SITES[rogue.site.id] || 'rogue'
    const bvSiteLocale = BV_LOCALE_SITES[rogue.site.id] || 'en_US'

    const folder = rogue.keys.bv.env === 'staging' ? 'staging' : 'production'

    script = `https://apps.bazaarvoice.com/deployments/${bvSiteCode}/main_site/${folder}/${bvSiteLocale}/bv.js`
    asyncLoad = true
  }

  if (script === 'spreedly') {
    // https://developer.spreedly.com/docs/iframe-integrity-hashes
    script = 'https://core.spreedly.com/iframe/iframe-v1.min.js'
    // sriHash = 'sha384-vLtQk4UE9CR+0If14k0mWAB7gBXUv5XMetNB1YS6mFwnaGuJTz600hKk/beQlu44'
  }

  if (script === 'recaptcha') {
    script = `https://www.google.com/recaptcha/enterprise.js?render=${rogue.keys.recaptchaSiteKey}`
    asyncLoad = true
  }

  if (!loadedScripts[script]) {
    const promise = new Promise((resolve, reject) => {
      const element = document.createElement('script')

      element.onload = resolve
      element.onerror = reject

      if (asyncLoad) {
        element.setAttribute('async', 'async')
      }
      element.setAttribute('src', script)
      if (id) {
        element.setAttribute('id', id)
      }
      if (sriHash) {
        element.setAttribute('integrity', sriHash)
        element.setAttribute('crossorigin', 'anonymous')
      }
      if (addToBody) {
        document.body.appendChild(element)
      } else {
        document.head.appendChild(element)
      }
    })

    loadedScripts[script] = promise
  }

  return loadedScripts[script]
}
